module.exports = __webpack_public_path__ + "img/20180815_152858_218.ca149458.jpg";